import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const SingleBlindedPeerReview = ({setFooterText,setIncludeDefault}) => {
  useEffect(() => {
    setFooterText('')
    setIncludeDefault(true)
   }, [])
  return (
    <React.Fragment>
      <Helmet>
        <title>Peer Review Process | Single-Blind Peer Review | Cureus</title>
        <meta name='description' content="Explore Cureus' peer review process. Learn how our expert reviewers assess research through single-blind peer reviews. View our author guide to learn more." />
      </Helmet>
      <h1>Peer Review</h1>
      <h2>Single-Blind, Pre-Publication Peer Review</h2>
      <p><a href='/'>Cureus</a> is a formally peer-reviewed medical journal. All articles accepted for peer review undergo a single-blind, pre-publication <a href='/reviewer_guide#!/how-it-works/introduction'>peer review process</a> in which reviewers know the identity of the authors, but authors do not know the identity of the reviewers.</p>
      <p>Reviewers are made anonymous through Cureus' automated system. Once a reviewer accepts the review invitation, they are assigned a Greek letter to be used for identification purposes by the authors (e.g. Reviewer Alpha).</p>

      <h3>Additional Information:</h3>
      <ul className='disc indented-for-medium-up'>
        <li>Any supplemental material included with the article is also subject to peer review.</li>
        <li>Reviews are not posted with the published articles.</li>
        <li>Medical students are ineligible to serve as peer reviewers.</li>
        <li>Advisers are not considered peer reviewers and adviser feedback is not considered during article evaluation by independent Cureus editors.</li>
        <li>Peer review can be completed from desktop, tablet or mobile devices.</li>
      </ul>
      <h2>Requirements to Satisfy Peer Review</h2>
      <p>Two completed reviews from independent peer reviewers are required to satisfy peer review. Six peer reviewers are automatically invited from the Cureus internal peer review panel, consisting of <a href='/associate_editors'>Cureus Editorial Board members</a> and relevant specialists who have either volunteered for the panel or previously published as an author in Cureus.</p>
      <p>Reviewers are selected based on specialty, reviewer keywords, and activity. To prevent a potential conflict of interest, peer reviewers with the same listed affiliation as one or more co-authors will not be invited to review your manuscript. Submitted peer reviews lacking in constructive feedback will be rejected by Cureus editors.</p>
      <p>Once the article has entered peer review, three additional peer reviewers are automatically invited by Cureus every two days to ensure that the article completes the peer review process in a timely fashion.</p>
    </React.Fragment>
  )
}

export default SingleBlindedPeerReview